import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';

import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getNoticeList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getNoticeList',
        parameter: {
            id: action.id
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getNoticeList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getNoticeListSaga = takeEvery('GetNoticeList_Saga', getNoticeList);

function* sendNotice(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/sendNotice',
        parameter: {
            id: action.id,
            contents: action.contents,
            title: action.title,
            target: action.target,
            targetID: action.targetID,
            expireDate: action.expireDate,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "sendNotice",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const sendNoticeSaga = takeEvery('SendNotice_Saga', sendNotice);

function* deleteNotice(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/deleteNotice',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(action.index);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "deleteNotice",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const deleteNoticeSaga = takeEvery('DeleteNotice_Saga', deleteNotice);

function* readNotice(action) {
    if (yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/readNotice',
        parameter: {
            noticeId: action.noticeId,
            expireDate: action.expireDate,
        },
    }
    const data = yield call(http.post, info);

    if (data.statusCode === 200){
        if (action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "readNotice",
            statusCode: data.statusCode,
            error: data.error,
        });
        if (action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}
export const readNoticeSaga = takeEvery('ReadNotice_Saga', readNotice);
